import type { VoidFunctionComponent } from 'react';

import { SAVED_REPORT_OPTIONS } from '../../../../../../../../shared/featureFlags/flagNames';
import { FeatureFlagRequired } from '../../../../../../generic';
import type { PartialReportConfig } from '../../../../../../../../shared/reports/types';

import { SavedOptions } from './SavedOptions';
import { SavedOptionsLabel } from './SavedOptionsLabel';

import styles from './Option.module.less';

type Props = {
  currentConfig: PartialReportConfig;
  handleSavedOptionApply: (config: PartialReportConfig | null) => void;
  isSavedOptionDirty: boolean;
};

/**
 * Container for the Saved Options component that combines the label, tooltip, and dropdown into a single component for
 * easier reuse.
 */
export const SavedOptionsContainer: VoidFunctionComponent<Props> = ({
  currentConfig,
  handleSavedOptionApply,
  isSavedOptionDirty,
}) => {
  return (
    <FeatureFlagRequired flagName={SAVED_REPORT_OPTIONS}>
      <div className={styles.savedOptionsContainer}>
        <SavedOptionsLabel />
        <SavedOptions
          currentConfig={currentConfig}
          onApply={handleSavedOptionApply}
          isSavedOptionDirty={isSavedOptionDirty}
        />
      </div>
    </FeatureFlagRequired>
  );
};
